import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventInvoicingReadinessQueryVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
}>;


export type GetEventInvoicingReadinessQuery = { __typename?: 'Query', getEventInvoicingReadiness: Array<{ __typename?: 'EventInvoicingReadiness', event_account_id: string, uncounted_container_station_ids: Array<string>, not_allowed_container_type_ids: Array<number>, missing_prices_container_type_ids: Array<number>, full_event_with_more_than_one_billable_account: boolean, wrong_class_container_type_ids: Array<number>, missing_sku_container_type_ids: Array<number>, not_allowed_item_type_ids: Array<number>, missing_prices_item_type_ids: Array<number>, missing_sku_item_type_ids: Array<number>, missing_main_contractor: boolean }> };


export const GetEventInvoicingReadinessDocument = gql`
    query GetEventInvoicingReadiness($event_id: ID!) {
  getEventInvoicingReadiness(event_id: $event_id) {
    event_account_id
    uncounted_container_station_ids
    not_allowed_container_type_ids
    missing_prices_container_type_ids
    full_event_with_more_than_one_billable_account
    wrong_class_container_type_ids
    missing_sku_container_type_ids
    not_allowed_item_type_ids
    missing_prices_item_type_ids
    missing_sku_item_type_ids
    missing_main_contractor
  }
}
    `;

/**
 * __useGetEventInvoicingReadinessQuery__
 *
 * To run a query within a React component, call `useGetEventInvoicingReadinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventInvoicingReadinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventInvoicingReadinessQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetEventInvoicingReadinessQuery(baseOptions: Apollo.QueryHookOptions<GetEventInvoicingReadinessQuery, GetEventInvoicingReadinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventInvoicingReadinessQuery, GetEventInvoicingReadinessQueryVariables>(GetEventInvoicingReadinessDocument, options);
      }
export function useGetEventInvoicingReadinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventInvoicingReadinessQuery, GetEventInvoicingReadinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventInvoicingReadinessQuery, GetEventInvoicingReadinessQueryVariables>(GetEventInvoicingReadinessDocument, options);
        }
export type GetEventInvoicingReadinessQueryHookResult = ReturnType<typeof useGetEventInvoicingReadinessQuery>;
export type GetEventInvoicingReadinessLazyQueryHookResult = ReturnType<typeof useGetEventInvoicingReadinessLazyQuery>;
export type GetEventInvoicingReadinessQueryResult = Apollo.QueryResult<GetEventInvoicingReadinessQuery, GetEventInvoicingReadinessQueryVariables>;